import { render, staticRenderFns } from "./ThePageFooter.vue?vue&type=template&id=81d594ea&"
import script from "./ThePageFooter.vue?vue&type=script&lang=js&"
export * from "./ThePageFooter.vue?vue&type=script&lang=js&"
import style0 from "./ThePageFooter.vue?vue&type=style&index=0&id=81d594ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports